import { createGlobalStyle, css } from 'styled-components';
import 'rc-menu/assets/index.css';

const styles = css`
  border: none !important;
  min-width: 240px !important;

  ${({ theme }) => css`
    background: ${theme.color.surface.baseline} !important;
    border-radius: ${theme.radius.small}px !important;
  `};

  padding: 8px 0 !important;
  outline: none !important;

  .rc-menu-item-divider {
    margin: 8px 0 !important;
    background: ${({ theme }) => theme.color.border.emphasis};
  }

  .rc-menu-item-group {
    ul {
      padding-left: 0px;
    }

    .rc-menu-item-group-list {
      li {
        list-style: none;
      }
    }

    .rc-menu-item-group-title {
      padding: 8px 16px !important;
      color: ${({ theme }) => theme.color.tint.secondary};
      ${({ theme }) => theme.mappedTypography.captionLarge.default};
      border: none;
    }
  }

  .ui-menu-item {
    height: 40px;
    padding: 8px 16px !important;
    color: ${({ theme }) => theme.color.tint.action};

    ${({ theme }) => theme.mappedTypography.overline.default};

    &.rc-menu-item-selected {
      background: ${({ theme }) => theme.color.surface.baseline};
    }

    &.ui-menu-item-danger {
      color: ${({ theme }) => theme.color.tint.error};
    }

    &.ui-menu-item-success {
      color: ${({ theme }) => theme.color.tint.success};
    }

    &.rc-menu-item-disabled {
      opacity: 0.5;
    }

    &.rc-menu-item-active {
      cursor: pointer;
      background: ${({ theme }) => theme.color.state.hover};
    }

    .ui-menu-item-icon {
      margin-right: 16px;
    }

    &-selected {
      background: none;
      &:after {
        display: none;
      }
    }

    .ui-menu-item-inner {
      display: flex;
      align-items: center;
      height: 100%;

      .ui-menu-item-children {
        flex: 1;
      }

      .ui-menu-item-check,
      .ui-menu-item-checkbox {
        margin-left: 16px;
        pointer-events: none;
      }
    }
  }

  .rc-menu-submenu {
    &.rc-menu-submenu-active {
      .rc-menu-submenu-title {
        cursor: pointer;
        background: ${({ theme }) => theme.color.state.hover};
      }
    }

    .rc-menu-submenu-title {
      color: ${({ theme }) => theme.color.tint.action};
      ${({ theme }) => theme.mappedTypography.overline.default};
    }
  }
`;

export const MenuStyles = createGlobalStyle`
  .ui-menu {
    ${styles};
  }
`;
